export default __webpack_public_path__ + "static/kitchenaid-mixer-9dabc3326a264a8caa21acb9a58eb154.jpg";